import { BaseType } from '../../../models/base/base-type';
import { FiduciaryEntityTypeEnum } from '../enums/fiduciary-entity-type.enum';

export class FiduciaryEntityType extends BaseType {
  public declare id: FiduciaryEntityTypeEnum;
}
